<template>
    <div  :class="navigateButtons && 'p-ai-center p-grid p-jc-center'">
     <div
            :class="navigateButtons && 'p-col'"
        >
            <div :class="navigateButtons && 'p-inputgroup'">
                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'התלמיד הקודם'"
                        @click="navigateDays(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        style="text-align: center"
                        :optionDisabled="'disabled'"
                        :filter="true"
                        filterPlaceholder="הקלד משפחה"
                        emptyFilterMessage=" לא נמצא שם משפחה"
                        placeholder="תלמיד"
                        data-key="id"
                        dataKey="id"
                        optionLabel="lastname"
                        v-model="selectPupil"
                        :options="getPupils"
                        @change="onSelect"
                >
                    <template #value="slotProps">
                            <div v-if="slotProps.value">{{slotProps.value && slotProps.value.firstname}} {{slotProps.value && slotProps.value.lastname}} </div>
                    </template>
                    <template #option="slotProps">
                        <div >
                            <div>{{slotProps.option.lastname}} {{slotProps.option.firstname}}</div>
                        </div>
                    </template>
                </Dropdown>

                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'התלמיד הבא'"
                        @click="navigateDays(true)"
                        icon="pi  pi-angle-down"
                        :class="navigateButtons && 'plus p-button-secondary p-inputgroup-addon'"
                ></Button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {mapState} from "vuex";

export default {
    props: {
        storageName: {
            type: String,
            default: "default"
        },
        navigateButtons:{
            type: Boolean,
            default: false
        },
        useStore:{
            type: Boolean,
            default: false
        },
        defaultValue: {
            type: String,
            default: null
        },
        replaceOptions:{
            type: Array,
            default: null
        },
        specificOptions:{
            type: Array,
            default: null
        }
    },
    name: "selectTeacher",
    data: () => ({
        selectPupil: null
    }),
    methods: {

        onSelect() {
            if(this.useStore){
                Vue.ls.set(`selectPupil_${this.storageName}`, this.selectPupil)
            }
            this.$emit('onSelect', this.selectPupil.id);
        },
        navigateDays(isAdd) {
            const index = this.pupils.findIndex(
                (pupil) => pupil.id === this.selectPupil.id
            );
            this.selectPupil =
                this.pupils[
                ((isAdd ? index + 1 : index - 1) + this.pupils?.length) %
                this.pupils?.length
                    ];
            this.onSelect()
        },
    },
    computed: {
        getPupils(){
            const result = []
            // if (Array.isArray(this.replaceOptions) && this.replaceOptions.length > 0) {
            //     const  replacedTeachers = [...this.teachers]
            //     this.replaceOptions.forEach((teacher) => {
            //         const matchTeacherIndex = this.teachers.findIndex((t) => t.id === teacher.id)
            //         replacedTeachers[matchTeacherIndex] = teacher
            //     })
            //
            //     return replacedTeachers
            // }
            if (this.specificOptions){
               const specificPupils = this.pupils?.filter((teacher) => {
                   this.specificOptions.includes(teacher.id)
                })
                return specificPupils
            }
            return this.pupils ?? []
        },
        ...mapState([ "pupils"]),
    },
    mounted() {
        if (this.defaultValue !== null){
            this.selectPupil = this.pupils?.find(pupil => pupil.id === this.defaultValue)
            this.onSelect()
        } else if(this.useStore) {
            this.selectPupil = Vue.ls.get(`selectPupil_${this.storageName}`) || {id: 0}
            this.onSelect()
        }
    }
}
</script>

<style scoped>

</style>